import { render } from "./AcessoBling.vue?vue&type=template&id=1bd7e792&scoped=true"
import script from "./AcessoBling.vue?vue&type=script&lang=js"
export * from "./AcessoBling.vue?vue&type=script&lang=js"

import "./AcessoBling.vue?vue&type=style&index=0&id=1bd7e792&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd7e792"]])

export default __exports__